// import { useState, useEffect, useRef, useCallback } from "react";
// import {
//   useGetCompanyInfoQuery,
//   useGetCountriesQuery,
//   useGetStatesQuery,
//   useUpdateCompanySettingsMutation,
// } from "../redux/services/settingsApi";
// import { toast } from "sonner";

// const DEFAULT_OPERATION_HOURS: any[] = [];

// interface User {
//   id?: string;
//   name?: string;
//   company?: { name?: string; about?: string };
//   branches?: any[];
//   profile_image?: string;
//   account_type?: string;
// }

// export const useSettingController = (
//   accountType: "company" | "individual",
//   user?: User
// ) => {
//   const [companyLogo, setCompanyLogo] = useState<string | File | null>(null);
//   const [companyName, setCompanyName] = useState("");
//   const [aboutDescription, setAboutDescription] = useState("");
//   const [hasOtherBranch, setHasOtherBranch] = useState(false);
//   const [companyPhone, setCompanyPhone] = useState("");
//   const [companyAddress, setCompanyAddress] = useState("");
//   const [businessZone, setBusinessZone] = useState("");
//   const [selectedCountry, setSelectedCountry] = useState("");
//   const [selectedState, setSelectedState] = useState("");
//   const [operationHours, setOperationHours] = useState<any[]>(
//     DEFAULT_OPERATION_HOURS
//   );
//   const [countryPage, setCountryPage] = useState(1);

//   const {
//     data: companyInfoData,
//     isLoading: isCompanyInfoLoading,
//     refetch: refetchCompanyInfo,
//   } = useGetCompanyInfoQuery(undefined, { skip: !user?.id });

//   const {
//     data: countriesResponse,
//     isLoading: countriesLoading,
//     isFetching: countriesFetching,
//   } = useGetCountriesQuery({ page: countryPage, per_page: 50 });

//   useEffect(() => {
//     if (!countriesResponse?.meta || countriesFetching) return;
//     const { current_page, last_page } = countriesResponse.meta;
//     if (current_page < last_page) {
//       setCountryPage((prev) => prev + 1);
//     }
//   }, [countriesResponse, countriesFetching]);


//   const {
//     data: statesData = [],
//     isLoading: statesLoading,
//     isFetching: statesFetching,
//   } = useGetStatesQuery(selectedCountry, {
//     skip: !selectedCountry,
//   });

//   const handleCountryChange = useCallback((countryId: string) => {
//     setSelectedCountry(countryId);
//     setSelectedState(""); 
//   }, []);

//   const hasPrefilledRef = useRef(false);

//   useEffect(() => {
//     if (!user?.id) return;
//     if (!companyInfoData?.data?.companyInfo) return;
//     if (hasPrefilledRef.current) return;

//     const info = companyInfoData.data.companyInfo;

//     setCompanyName(info.company_name || user.company?.name || user.name || "");
//     setAboutDescription(info.about_company || "");
//     setHasOtherBranch(Boolean(info.has_other_branch));
//     setCompanyLogo(info.company_logo_url || user.profile_image || null);
//     setCompanyPhone(info.company_phone || "");
//     setCompanyAddress(info.company_address || "");
//     setBusinessZone(info.business_zone || "");

//     setSelectedCountry(info.country_id?.toString() || "");
//     setSelectedState(info.state_id?.toString() || "");

//     try {
//       let hours: any = info.operation_hours;
//       while (typeof hours === "string") hours = JSON.parse(hours);
//       if (Array.isArray(hours) && hours.length > 0) {
//         setOperationHours(
//           hours.map((h: any) => ({
//             id: Date.now() + Math.random(),
//             fromDay: h.fromDay || "",
//             fromHour: h.fromHour || "",
//             fromPeriod: h.fromPeriod || "",
//             toDay: h.toDay || "",
//             toHour: h.toHour || "",
//             toPeriod: h.toPeriod || "",
//           }))
//         );
//       } else {
//         setOperationHours(DEFAULT_OPERATION_HOURS);
//       }
//     } catch (err) {
//       console.error("❌ failed to parse operation_hours:", err);
//       setOperationHours(DEFAULT_OPERATION_HOURS);
//     }

//     hasPrefilledRef.current = true;
//   }, [companyInfoData, user]);

//   useEffect(() => {
//     hasPrefilledRef.current = false;
//   }, [user?.id]);

//   const [updateCompanySettings] = useUpdateCompanySettingsMutation();
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const submitProfile = async () => {
//     const companyId = companyInfoData?.data?.companyInfo?.id;
//     if (!companyId) {
//       toast.error("Company ID not found");
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       const payload: any = {
//         company_name: companyName || "",
//         about_company: aboutDescription || "",
//         has_other_branch: hasOtherBranch ? 1 : 0,
//         company_phone: companyPhone || "",
//         company_address: companyAddress || "",
//         business_zone: businessZone || "",
//         country_id: selectedCountry || "",
//         state_id: selectedState || "",
//         operation_hours: JSON.stringify(operationHours || []),
//       };

//       if (companyLogo instanceof File) payload.company_logo = companyLogo;

//       const response = await updateCompanySettings({
//         companyId: companyId.toString(),
//         data: payload,
//       }).unwrap();

//       toast.success(response?.data?.message || "Profile updated successfully");
//       await refetchCompanyInfo();
//     } catch (err: any) {
//       toast.error(err?.data?.message || "Failed to update profile");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return {
//     companyLogo,
//     setCompanyLogo,
//     companyName,
//     setCompanyName,
//     aboutDescription,
//     setAboutDescription,
//     hasOtherBranch,
//     setHasOtherBranch,
//     companyPhone,
//     setCompanyPhone,
//     companyAddress,
//     setCompanyAddress,
//     businessZone,
//     setBusinessZone,

//     selectedCountry,
//     setSelectedCountry: handleCountryChange,
//     selectedState,
//     setSelectedState,

//     countries: countriesResponse?.data ?? [],
//     countriesLoading: countriesLoading || countriesFetching,

//     states: statesData,
//     statesLoading: statesLoading || statesFetching,

//     operationHours,
//     setOperationHours,

//     submitProfile,
//     isSubmitting,

//     isLoading: isCompanyInfoLoading,

//     accountType,
//   };
// };


import { useState, useEffect, useRef, useCallback } from "react";
import {
  useGetCompanyInfoQuery,
  useGetCountriesQuery,
  useGetStatesQuery,
  useUpdateCompanySettingsMutation,
} from "../redux/services/settingsApi";
import { toast } from "sonner";
import { useAppDispatch, useAppSelector } from "../redux/services/store";
import { selectAuth, setAuthUser } from "../redux/slices/authSlice";

const DEFAULT_OPERATION_HOURS: any[] = [];

interface User {
  id?: string;
  name?: string;
  company?: { name?: string; about?: string };
  branches?: any[];
  profile_image?: string;
  account_type?: string;
}

export const useSettingController = (
  accountType: "company" | "individual",
  user?: User
) => {
  const [companyLogo, setCompanyLogo] = useState<string | File | null>(null);
  const [companyName, setCompanyName] = useState("");
  const [aboutDescription, setAboutDescription] = useState("");
  const [hasOtherBranch, setHasOtherBranch] = useState(true);
  const [companyPhone, setCompanyPhone] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [businessZone, setBusinessZone] = useState("");
  const [paymentTiming, setPaymentTiming] = useState<"before_delivery" | "after_delivery">("after_delivery");
  // Which payment methods the company accepts for "after delivery" orders.
  // Irrelevant for "before delivery" (that's wallet-only), and null on the
  // backend means "never set" — treated as both accepted for display.
  const [allowedPaymentMethods, setAllowedPaymentMethods] = useState<string[]>(["cash", "wallet"]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [operationHours, setOperationHours] = useState<any[]>(DEFAULT_OPERATION_HOURS);
  const [countryPage, setCountryPage] = useState(1);

  const {
    data: companyInfoData,
    isLoading: isCompanyInfoLoading,
    refetch: refetchCompanyInfo,
  } = useGetCompanyInfoQuery(undefined, { skip: !user?.id });

  const {
    data: countriesResponse,
    isLoading: countriesLoading,
    isFetching: countriesFetching,
  } = useGetCountriesQuery({ page: countryPage, per_page: 50 });

  useEffect(() => {
    if (!countriesResponse?.meta || countriesFetching) return;
    const { current_page, last_page } = countriesResponse.meta;
    if (current_page < last_page) {
      setCountryPage((prev) => prev + 1);
    }
  }, [countriesResponse, countriesFetching]);

  const {
    data: statesData = [],
    isLoading: statesLoading,
    isFetching: statesFetching,
  } = useGetStatesQuery(selectedCountry, {
    skip: !selectedCountry,
  });

  const handleCountryChange = useCallback((countryId: string) => {
    setSelectedCountry(countryId);
    setSelectedState("");
  }, []);

  const hasPrefilledRef = useRef(false);

  useEffect(() => {
    if (!user?.id) return;
    if (!companyInfoData?.data?.companyInfo) return;
    if (hasPrefilledRef.current) return;

    const info = companyInfoData.data.companyInfo;

    setCompanyName(info.company_name || user.company?.name || user.name || "");
    setAboutDescription(info.about_company || "");
    setHasOtherBranch(
      info.has_other_branch === undefined || info.has_other_branch === null
        ? true
        : Boolean(info.has_other_branch)
    );

    setCompanyLogo(info.company_logo || null);

    setCompanyPhone(info.company_phone || "");
    setSupportEmail(info.support_email || "");
    setCompanyAddress(info.company_address || "");
    setBusinessZone(info.business_zone || "");
    setPaymentTiming(info.payment_preference === "before_delivery" ? "before_delivery" : "after_delivery");
    setAllowedPaymentMethods(
      Array.isArray(info.allowed_payment_methods) && info.allowed_payment_methods.length > 0
        ? info.allowed_payment_methods
        : ["cash", "wallet"]
    );
    setSelectedCountry(info.country_id?.toString() || "");
    setSelectedState(info.state_id?.toString() || "");

    try {
      let hours: any = info.operation_hours;
      while (typeof hours === "string") hours = JSON.parse(hours);
      if (Array.isArray(hours) && hours.length > 0) {
        setOperationHours(
          hours.map((h: any) => ({
            id: Date.now() + Math.random(),
            fromDay: h.fromDay || "",
            fromHour: h.fromHour || "",
            fromPeriod: h.fromPeriod || "",
            toDay: h.toDay || "",
            toHour: h.toHour || "",
            toPeriod: h.toPeriod || "",
          }))
        );
      } else {
        setOperationHours(DEFAULT_OPERATION_HOURS);
      }
    } catch (err) {
      console.error("❌ failed to parse operation_hours:", err);
      setOperationHours(DEFAULT_OPERATION_HOURS);
    }

    hasPrefilledRef.current = true;
  }, [companyInfoData, user]);

  useEffect(() => {
    hasPrefilledRef.current = false;
  }, [user?.id]);

  const [updateCompanySettings] = useUpdateCompanySettingsMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);

  const submitProfile = async () => {
    const companyId = companyInfoData?.data?.companyInfo?.id;
    if (!companyId) {
      toast.error("Company ID not found");
      return;
    }

    // Mirrors the backend's validation: when "after delivery" is selected,
    // at least one payment method must be accepted.
    if (paymentTiming === "after_delivery" && allowedPaymentMethods.length === 0) {
      toast.error("Select at least one payment method your company accepts.");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload: any = {
        company_name: companyName || "",
        about_company: aboutDescription || "",
        has_other_branch: hasOtherBranch ? 1 : 0,
        company_phone: companyPhone || "",
        support_email: supportEmail || "",
        company_address: companyAddress || "",
        business_zone: businessZone || "",
        payment_preference: paymentTiming,
        allowed_payment_methods: allowedPaymentMethods,
        country_id: selectedCountry || "",
        state_id: selectedState || "",
        operation_hours: JSON.stringify(operationHours || []),
      };

      if (companyLogo instanceof File) payload.company_logo = companyLogo;

      const response = await updateCompanySettings({
        companyId: companyId.toString(),
        data: payload,
      }).unwrap();

      toast.success(response?.data?.message || "Profile updated successfully");

      if (auth.user) {
        dispatch(
          setAuthUser({
            token: auth.token,
            user: { ...auth.user, has_branch: hasOtherBranch ? 1 : 0 },
          })
        );
      }

      await refetchCompanyInfo();
    } catch (err: any) {
      toast.error(err?.data?.message || "Failed to update profile");
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    companyLogo,
    setCompanyLogo,
    companyName,
    setCompanyName,
    aboutDescription,
    setAboutDescription,
    hasOtherBranch,
    setHasOtherBranch,
    companyPhone,
    setCompanyPhone,
    supportEmail,
    setSupportEmail,
    companyAddress,
    setCompanyAddress,
    businessZone,
    setBusinessZone,
    paymentTiming,
    setPaymentTiming,
    allowedPaymentMethods,
    setAllowedPaymentMethods,
    selectedCountry,
    setSelectedCountry: handleCountryChange,
    selectedState,
    setSelectedState,
    countries: countriesResponse?.data ?? [],
    countriesLoading: countriesLoading || countriesFetching,
    states: statesData,
    statesLoading: statesLoading || statesFetching,
    operationHours,
    setOperationHours,
    submitProfile,
    isSubmitting,
    isLoading: isCompanyInfoLoading,
    accountType,
  };
};